let spImgList = [
  "https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-s1-s.png?v=1719542523",
  "https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-s2-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-s3-s.png?v=1719890538",
    "https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-p4-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-s1.png",
  "https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-s2.png?v=1719890538",
  "https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-s3.png?v=1719890537",
"https://cdn.shopifycdn.net/s/files/1/0756/1596/1370/files/20240628-p4.png",
  ]
function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();
    
   $('.selectl span').click(function(){
            $(this).addClass("on").siblings().removeClass("on");
            $(this).parent().parent().find('span#price1').text($(this).data('price'))
            $(this).parent().parent().find('span#price2').text($(this).data('compare'))
               let price = $(this).data('price')
             let compare = $(this).data('compare')
             let off_font = 100 - Math.ceil(price / compare * 100)
     $(this).parents('.product-box').find('.sp-brand2 span').html(off_font)
        })
      preloadImages(spImgList);
    

      $('.sp-btn-style').on('click',function(){
          let id = $(this).siblings('.selectl').find('span.on').data('id');

          if($(this).attr('data-num')){
            id = $(this).siblings('.flex-bet').find('span.on').data('id');
          }
          window.location.href = '/cart/' + id + ':1'
        })
      
$(".selectl span").click(function () {
  $(this).addClass("on").siblings().removeClass("on");
  let p_img = $(this).parents(".product-box").find(".p-img")[0];
  let _numIndex = $(this).parents(".product-box").index();
  let _sizeIndex = $(this).index();
  const brand =$(this).attr('data-brand') 
  if(brand) {
     $(this).parents(".product-box").find("#sp-brand3").show();
  }else{
    $(this).parents(".product-box").find("#sp-brand3").hide();
  }
  p_img.src = spImgList[_numIndex + _sizeIndex * 4];
 
});
 $("#sp-brand3").show()

    
    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            140 * $("div#root").css("zoom") +
            10,
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

